// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AP0bz{position:relative}.lEH5S.ui.dropdown .baVxx{background-color:var(--anchore-background-color-card)}.lEH5S.ui.dropdown .baVxx.nfNaG .sC3RA.item{width:10rem}.lEH5S.ui.dropdown .baVxx.nfNaG .sC3RA.item.active.avdEQ{background-color:revert!important;width:35rem;z-index:13}.lEH5S.ui.dropdown .baVxx.nfNaG .sC3RA.item.active.avdEQ:hover{background-color:inherit}.lEH5S.ui.dropdown .baVxx.nfNaG .sC3RA.item.active.avdEQ .g2kHI{display:flex;gap:1.5rem;height:5.5rem}.lEH5S.ui.dropdown .baVxx .e4_nD{display:flex;flex-direction:column;font-weight:400;gap:1rem;padding:1rem;position:absolute;right:1rem;top:-20.5rem}.lEH5S.ui.dropdown .baVxx .e4_nD .ejprS .ui.input{display:inline-flex;font-size:.8rem!important;margin:0!important}.lEH5S.ui.dropdown .baVxx .e4_nD .ejprS .ui.input input{width:8rem}.lEH5S.ui.dropdown .baVxx .e4_nD .oA_Ib{display:inline-flex;gap:1rem;justify-content:flex-end}.U6kVV{height:19.2rem}.react-datepicker .react-datepicker__day,.react-datepicker .react-datepicker__day-name{line-height:2rem;width:2.8rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `AP0bz`,
	"dropdown": `lEH5S`,
	"dropdownMenu": `baVxx`,
	"customRangeIsActive": `nfNaG`,
	"dropdownItem": `sC3RA`,
	"customRangeOption": `avdEQ`,
	"customRangeContent": `g2kHI`,
	"rangePicker": `e4_nD`,
	"rangePickerInputs": `ejprS`,
	"rangePickerActions": `oA_Ib`,
	"calendar": `U6kVV`
};
module.exports = ___CSS_LOADER_EXPORT___;
